class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

document.addEventListener('click', function (e) {

  const link = e.target.closest(
    'a.f-mobile-nav__link, a.f-mobile-nav__sub-link'
  );

  if (!link) return;

  const item = link.closest('li');
  if (!item) return;

  // Vérifie si cet item possède un sous-menu
  const trigger = item.querySelector(':scope > collapsible-tab [data-trigger]');
  const content = item.querySelector(':scope > collapsible-tab [data-content]');

  if (!trigger || !content) {
    // pas d'enfants -> navigation normale
    return;
  }

  // empêche la navigation et ouvre le menu
  e.preventDefault();
  trigger.click();

});